import FsLightbox from 'fslightbox-react'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';

const Project = ({img1 , img2 , img3}) => {
        const [toggler, setToggler] = useState(false);
    const images = [
        img1 , img2 , img3
    ];
   const {t} = useTranslation()
  return (
    <div className='relative z-10'>
         <div className=" mx-12  shadow-inner-white  border-[#0000ff] rounded-3xl border-4">
                <h1 className='text-center xs:text-2xl xxs:text-2xl sm:text-3xl font-bold  font-serif text-white mb-5  mt-3'>{t("LightBox")}</h1>

      <div className="grid shadow-white shadow-xl lg:grid-cols-3 md:grid-cols-2 mb-8 sm:grid-cols-1 xxs:grid-cols-1 xs:grid-cols-1   border-2 border-white lg:gap-2 lg:mx-10">
            { images.map( (img) => (<div className="border-white border flex justify-center p-2">  <button onClick={() => setToggler(!toggler)}>
				<img className="h-96" src={img} height={"100px"} alt="" srcset="" />
			          </button> 
                 </div>) )
            }
            </div>
			<FsLightbox
				toggler={toggler}
				sources={[
					          img1,
                    img2,
                    img3,
				]}
			/>
            <div></div>
    </div>
    </div>
  )
}

export default Project
